import React from 'react';

type Props = {
  message: string | null;
  onDismiss: () => void;
};

const Toast: React.FC<Props> = ({ message, onDismiss }) => {
  if (!message) return null;

  return (
    <div className="fixed bottom-4 right-4 bg-error text-newsprint px-4 py-2 rounded-sm shadow-lg flex items-center gap-2 animate-fade-in">
      <span>{message}</span>
      <button onClick={onDismiss} className="font-bold hover:opacity-70" type="button">
        ×
      </button>
    </div>
  );
};

export default Toast;
